import { NAME as AUTH_NAME } from '../constants';

export const getProfiles = (state) => {
  try {
    const { profiles } = state.circe.authorization;
    return Object.values(profiles);
  } catch (e) {
    return [];
  }
};
export const getCurrentProfile = (state) => {
  try {
    const { profile } = state.app.auth;
    return profile;
  } catch (e) {
    console.warn(`[${AUTH_NAME}][AUTH] No profile`);
    return {};
  }
};
